import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'

const FETCH_FEATURE = 'categories/FETCH_FEATURE'
const FETCH_FEATURE_SUCCESS = 'categories/FETCH_FEATURE_SUCCESS'
const FETCH_FEATURE_FAIL = 'categories/FETCH_FEATURE_FAIL'

export const ACTIONS = {
  FETCH_FEATURE,
  FETCH_FEATURE_SUCCESS,
  FETCH_FEATURE_FAIL
}

export const initialState = {}

export default (state = initialState, { type, requestPayload }) => {
  switch (type) {
    case FETCH_FEATURE:
      return {
        ...state
      }
    case FETCH_FEATURE_SUCCESS:
      return {
        ...state,
        [requestPayload.featureName]: true
      }
    case FETCH_FEATURE_FAIL:
      return {
        ...state,
        [requestPayload.featureName]: false
      }
    default:
      return state
  }
}

export const fetchFeature = (featureName) => {
  return {
    type: CALL_API,
    types: [FETCH_FEATURE, FETCH_FEATURE_SUCCESS, FETCH_FEATURE_FAIL],
    payload: { featureName: featureName },
    callAPI: () =>
      axios.get(`/adminfeature?featureName=${featureName}`, {
        headers: { 'x-api': 'ADMIN_FEATURE_V1' }
      })
  }
}



// WEBPACK FOOTER //
// ./src/modules/Positions/reducers/features.js